<template>
  <ul class="menu-nav">
    <!-- Dashboard entry -->

    <router-link :to="routes.home.path" v-slot="{ isActive, isExactActive }" class="menu-item">
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <DashboardIcon />
        <span class="menu-text">{{ translate("MENU.DASHBOARD") }}</span>
      </span>
    </router-link>

    <!-- BUYBACKS SECTION -->

    <li class="menu-section" v-if="hasPermission(userConstants.ROLE_BUYBACK_MENU)">
      <h4 class="menu-text">
        {{ translate("MENU.BUYBACKS_SECTION").toUpperCase() }}
      </h4>
    </li>

    <!-- Catalog sub-menu -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
      v-if="hasPermission(userConstants.ROLE_CATALOG_SUBMENU)"
    >
      <a class="menu-link cirx-menu-link menu-toggle menu-item-open">
        <CatalogIcon />
        <span class="menu-text">{{ translate("MENU.CATALOG_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.CATALOG_SUBMENU") }}</span>
            </span>
          </li>

          <!-- Categories entry -->

          <router-link
            :to="routes.categories.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_CATEGORY_LIST_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.CATEGORIES") }}</span>
            </span>
          </router-link>

          <!-- Products entry -->

          <router-link
            :to="routes.products.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_PRODUCT_LIST_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.PRODUCTS") }}</span>
            </span>
          </router-link>

          <!-- Diagnostic entry -->

          <router-link
            :to="routes.diagnostic.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_QUESTION_LIST_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.DIAGNOSTIC") }}</span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- Buybacks sub-menu -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
      v-if="hasPermission(userConstants.ROLE_BUYBACK_SUBMENU)"
    >
      <a class="menu-link cirx-menu-link menu-toggle">
        <BuybackIcon />
        <span class="menu-text">{{ translate("MENU.BUYBACKS_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.BUYBACKS_SUBMENU") }}</span>
            </span>
          </li>

          <!-- Buybacks list entry -->

          <router-link
            :to="routes.buybacks.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
            v-if="hasPermission(userConstants.ROLE_BUYBACK_LIST_PAGE)"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.BUYBACKS") }}</span>
            </span>
          </router-link>

          <!-- New buyback entry -->

          <router-link
            :to="routes.buybackSearch.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
            v-if="hasPermission(userConstants.ROLE_BUYBACK_CREATE_PAGE)"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.BUYBACK_NEW") }}</span>
            </span>
          </router-link>

          <!-- Buybacks Pre Declared list entry -->

          <router-link
            :to="routes.buybacks_predeclared.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
            v-if="hasPermission(userConstants.ACCESS_PREDECLARED_BUYBACKS)"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.BUYBACKS_PREDECLARED") }}</span>
            </span>
          </router-link>

          <!-- Buybacks expeditions entry -->

          <router-link
            :to="routes.startExpedition.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_BUYBACKITEM_SEND_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">
                {{ translate("MENU.BUYBACKS_EXPEDITIONS") }}
              </span>
            </span>
          </router-link>

          <!-- Buybacks check in -->
          <router-link
            :to="routes.checkinWarehouse.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_WAREHOUSE_CHECKIN_SUBMENU) && !isWarehouseCheckinDisabled"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.BUYBACKS_REGISTER") }}</span>
            </span>
          </router-link>

          <!-- Buybacks check entry -->

          <router-link
            :to="routes.complianceTest.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_BUYBACKITEM_CONTROL_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.BUYBACKS_CHECK") }}</span>
            </span>
          </router-link>

          <!-- Buybacks quarantine entry -->

          <router-link
            :to="routes.buybacksQuarantine.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_BUYBACKITEM_QUARANTINE_TRANSITION_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">
                {{ translate("MENU.BUYBACKS_QUARANTINE") }}
              </span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- TRAITEMENT/REFURB/RECONDITIONNEMENT" SECTION -->
    <li
      class="menu-section"
      v-if="
        hasPermission(userConstants.ROLE_REFURB_STEP_MANAGE) ||
        hasPermission(userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE) ||
        hasPermission(userConstants.ROLE_ITEMS_STOCK_READ) ||
        hasPermission(userConstants.ROLE_STOCK_MANAGE)
      "
    >
      <h4 class="menu-text">
        {{ translate("MENU.REFURB_SECTION").toUpperCase() }}
      </h4>
    </li>

    <!--  TRAITEMENT/REFURB/"RECONDITIONNEMENT sub-menu -->
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
      v-if="
        hasPermission(userConstants.ROLE_REFURB_STEP_MANAGE) ||
        hasPermission(userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE) ||
        hasPermission(userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE)
      "
    >
      <a class="menu-link cirx-menu-link menu-toggle">
        <RefurbIcon />
        <span class="menu-text">{{ translate("MENU.REFURB_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>

      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.REFURB_SUBMENU") }}</span>
            </span>
          </li>

          <!-- Refurb Diagnostic entry -->
          <router-link
            :to="routes.refurbDiagnosisQuestions.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_REFURB_DIAGNOSTIC_MANAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.REFURB_DIAGNOSTIC") }}</span>
            </span>
          </router-link>

          <!-- Start Refurb Diagnostic -->
          <router-link
            :to="routes.refurbDiagnosisStart.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_REFURB_DIAGNOSTIC_WRITE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.REFURB_DIAGNOSTIC_START") }}</span>
            </span>
          </router-link>

          <!-- Start Item Refurb Step -->
          <router-link
            :to="routes.searchItemRefurbSteps.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_REFURB_WRITE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.REFURB_ITEM_REFURB_STEP_START") }}</span>
            </span>
          </router-link>

          <!-- Refurb Steps list -->
          <router-link
            :to="routes.refurbSteps.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_REFURB_STEP_MANAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.REFURB_STEPS_LIST") }}</span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- Stocks sub-menu -->
    <li
      v-if="hasPermission(userConstants.ROLE_ITEMS_STOCK_READ) || hasPermission(userConstants.ROLE_STOCK_MANAGE)"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
    >
      <a class="menu-link cirx-menu-link menu-toggle">
        <StockIcon />
        <span class="menu-text">{{ translate("MENU.STOCK_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.STOCK_SUBMENU") }}</span>
            </span>
          </li>
          <!-- Stocks list entry -->

          <router-link
            v-if="hasPermission(userConstants.ROLE_STOCK_MANAGE)"
            :to="routes.stocks.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.STOCKS") }}</span>
            </span>
          </router-link>

          <!-- Items in Stock list entry -->

          <router-link
            v-if="hasPermission(userConstants.ROLE_ITEMS_STOCK_READ)"
            :to="routes.itemsStock.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.ITEMS_STOCK") }}</span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- CONFIGURATION SECTION -->

    <li class="menu-section" v-if="hasPermission(userConstants.ROLE_CONFIGURATION_MENU)">
      <h4 class="menu-text">
        {{ translate("MENU.CONFIGURATION_SECTION").toUpperCase() }}
      </h4>
    </li>

    <!-- Design entry -->

    <router-link
      :to="routes.design.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_DESIGN_PAGE)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <DesignIcon />
        <span class="menu-text">{{ translate("MENU.DESIGN") }}</span>
      </span>
    </router-link>

    <!-- Payment modes entry -->

    <router-link
      :to="routes.paymentModes.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_PAYMENT_MODES_PAGE)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <PaymentModeIcon />
        <span class="menu-text">{{ translate("MENU.PAYMENT_MODES") }}</span>
      </span>
    </router-link>

    <!-- Circuit entry -->

    <router-link
      :to="routes.circuits.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_DISPATCH_CIRCUIT_RULE_LIST_PAGE)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <CircuitIcon />
        <span class="menu-text">{{ translate("MENU.CIRCUITS") }}</span>
      </span>
    </router-link>

    <!-- Warehouse dispatch entry -->

    <router-link
      :to="routes.warehouseDispatch.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_WAREHOUSE_DISPATCH_RULE_READ)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <WarehouseDispatchIcon />
        <span class="menu-text">{{ translate("MENU.WAREHOUSE_DISPATCH") }}</span>
      </span>
    </router-link>

    <!-- Organization sub-menu -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
      v-if="hasPermission(userConstants.ROLE_CONFIGURATION_MENU)"
    >
      <a class="menu-link cirx-menu-link menu-toggle" v-if="hasPermission(userConstants.ROLE_ORGANIZATION_SUBMENU)">
        <OrganizationIcon />
        <span class="menu-text">{{ translate("MENU.ORGANIZATION_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu" v-if="hasPermission(userConstants.ROLE_ORGANIZATION_SUBMENU)">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.ORGANIZATION_SUBMENU") }}</span>
            </span>
          </li>

          <!-- Users entry -->

          <router-link
            :to="routes.users.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_USER_LIST_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.USERS") }}</span>
            </span>
          </router-link>

          <!-- Entities entry -->

          <router-link
            :to="routes.entities.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_ORGANIZATION_LIST_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.ENTITIES") }}</span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- Home config entry - DISABLED for now / will need specific permission when enabled (= when permission goes from admin cirx to root manager) -->

    <!-- <router-link
      :to="routes.homeConfig.path"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link cirx-menu-link" @click="navigate">
          <PagesIcon />
          <span class="menu-text">{{ translate("MENU.PAGES") }}</span>
        </a>
      </li>
    </router-link> -->

    <!-- Settings sub-menu -->

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      @click="toggleMenu"
      v-if="hasPermission(userConstants.ROLE_CONFIGURATION_MENU)"
    >
      <a class="menu-link cirx-menu-link menu-toggle" v-if="hasPermission(userConstants.ROLE_SETTINGS_SUBMENU)">
        <SettingsIcon />
        <span class="menu-text">{{ translate("MENU.SETTINGS_SUBMENU") }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu" v-if="hasPermission(userConstants.ROLE_SETTINGS_SUBMENU)">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ translate("MENU.SETTINGS_SUBMENU") }}</span>
            </span>
          </li>

          <!-- TIM General settings entry -->

          <router-link
            :to="routes.timGeneralSettings.path"
            v-slot="{ isActive, isExactActive }"
            class="menu-item"
            v-if="hasPermission(userConstants.ROLE_GENERAL_SETTINGS_PAGE)"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.GENERAL_SETTINGS_TIM") }}</span>
            </span>
          </router-link>

          <!-- LCM General settings entry -->

          <router-link
            :to="routes.lcmRpsGeneralSettings.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_GENERAL_SETTINGS_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.GENERAL_SETTINGS_LCM_RPS") }}</span>
            </span>
          </router-link>

          <!-- SFTP General settings entry -->

          <router-link
            :to="routes.sftpSettings.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_GENERAL_SETTINGS_PAGE) && hasSftpAccess()"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text">{{ translate("MENU.GENERAL_SETTINGS_SFTP") }}</span>
            </span>
          </router-link>

          <!-- Transfer order settings entry -->

          <router-link
            :to="routes.transferOrderSettings.path"
            v-slot="{ isActive, isExactActive }"
            v-if="hasPermission(userConstants.ROLE_TRANSFER_ORDER_SETTINGS_PAGE)"
            class="menu-item"
          >
            <span class="menu-link" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <i class="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
              <span class="menu-text"
                >{{ translate("MENU.TRANSFER_ORDER_SETTINGS") }}<PremiumBadge small class="ml-3" />
              </span>
            </span>
          </router-link>
        </ul>
      </div>
    </li>

    <!-- CIRX ADMIN SECTION -->

    <li class="menu-section" v-if="hasPermission(userConstants.ROLE_ADMIN_MENU)">
      <h4 class="menu-text">
        {{ translate("MENU.CIRX_ADMIN_SECTION").toUpperCase() }}
      </h4>
    </li>

    <!-- Clients entry -->

    <router-link
      :to="routes.clients.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_CLIENT_LIST_PAGE)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <UsersIcon />
        <span class="menu-text">{{ translate("MENU.CLIENTS") }}</span>
      </span>
    </router-link>

    <!-- New client entry -->

    <router-link
      :to="routes.createClient.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_ADMIN_MENU)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <AddUserIcon />
        <span class="menu-text">{{ translate("MENU.NEW_CLIENT") }}</span>
      </span>
    </router-link>

    <!-- Transports List -->

    <router-link
      :to="routes.transportsList.path"
      v-slot="{ isActive, isExactActive }"
      v-if="hasPermission(userConstants.ROLE_ADMIN_MENU)"
      class="menu-item"
    >
      <span
        class="menu-link cirx-menu-link"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <span class="svg-icon menu-icon">
          <inline-svg src="/media/cirx/delivery_truck.svg" />
        </span>
        <span class="menu-text">{{ translate("MENU.TRANSPORTS_LIST") }}</span>
      </span>
    </router-link>
  </ul>
</template>

<script>
import { ref, watch } from "vue";
import identificationService from "@/core/services/identification.service";
import { routes as globalRoutes } from "@/routing/routes";
import * as userConstantsPermissions from "@/core/models/usersAndPermissions";
import DashboardIcon from "@/view/components/SidebarMenu/DashboardIcon.vue";
import CatalogIcon from "@/view/components/SidebarMenu/CatalogIcon.vue";
import BuybackIcon from "@/view/components/SidebarMenu/BuybackIcon.vue";
import OrganizationIcon from "@/view/components/SidebarMenu/OrganizationIcon.vue";
import UsersIcon from "@/view/components/SidebarMenu/UsersIcon.vue";
import AddUserIcon from "@/view/components/SidebarMenu/AddUserIcon.vue";
import DesignIcon from "@/view/components/SidebarMenu/DesignIcon.vue";
import PaymentModeIcon from "@/view/components/SidebarMenu/PaymentModeIcon.vue";
import SettingsIcon from "@/view/components/SidebarMenu/SettingsIcon.vue";
import PremiumBadge from "@/view/components/Shared/PremiumBadge.vue";
import CircuitIcon from "@/view/components/SidebarMenu/CircuitIcon.vue";
import WarehouseDispatchIcon from "@/view/components/SidebarMenu/WarehouseDispatchIcon.vue";
import StockIcon from "@/view/components/SidebarMenu/StockIcon.vue";
import RefurbIcon from "@/view/components/SidebarMenu/RefurbIcon.vue";
import { ORDservice } from "@/core/services/identification/organizationRootDetails.service";
import { useRoute } from "vue-router";
import useLayoutStore from "@/core/store/layout/layoutStore";
import useTranslate from "@/core/composables/translate";

export default {
  name: "Menu",

  components: {
    DashboardIcon,
    CatalogIcon,
    BuybackIcon,
    OrganizationIcon,
    UsersIcon,
    AddUserIcon,
    DesignIcon,
    PaymentModeIcon,
    SettingsIcon,
    PremiumBadge,
    CircuitIcon,
    RefurbIcon,
    WarehouseDispatchIcon,
    StockIcon,
  },

  setup() {
    const route = useRoute();

    const routes = ref(globalRoutes);

    const userConstants = ref(userConstantsPermissions);

    const { closeAside } = useLayoutStore();
    const isWarehouseCheckinDisabled = ref(ORDservice.isWarehouseCheckinDisabled());

    const hasPermission = (permission) => {
      return identificationService.hasPermission(permission);
    };

    const hasSftpAccess = () => {
      return ORDservice.getOrganizationRootDetails().enabledPremiumFeatures.includes("sftp_access");
    };
    const toggleMenu = (event) => {
      event.currentTarget.classList.toggle("menu-item-open");
      event.target.classList.toggle("menu-item-open");
    };

    watch(route, () => {
      closeAside();
    });

    const { translate } = useTranslate();

    return {
      routes,
      userConstants,
      isWarehouseCheckinDisabled,
      hasPermission,
      hasSftpAccess,
      toggleMenu,
      translate,
    };
  },
};
</script>

<style lang="scss">
.entry-disabled {
  pointer-events: none;
}
</style>
